export enum EMPLOYER_CREDIT_POLICY_TYPE {
  PAYROLL_LOAN = 'PAYROLL_LOAN',
  NEGATIVE_SCORE_PAYROLL_LOAN = 'NEGATIVE_SCORE_PAYROLL_LOAN',
  PAYCHECK_ADVANCE = 'PAYCHECK_ADVANCE',
}
